// Core
import styled from 'styled-components';

export const StyledSpecialEdition = styled.div`
cursor: pointer;
position: relative;
overflow: hidden;
border-radius: 22px;
aspect-ratio: 3 / 4;
background: #0b1f2e;
box-shadow: 0 10px 30px #0004;
transition: transform 0.4s, box-shadow 0.4s;

img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s;
}
.__shade {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, #0b1f2e00 35%, #0b1f2ef2 100%);
}
.__tag {
    position: absolute;
    top: 18px;
    left: 18px;
    padding: 4px 12px;
    border-radius: 20px;
    background: #d8a74a;
    color: #2b1b00;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
}
.__prem {
    position: absolute;
    top: 18px;
    right: 18px;
    padding: 4px 12px;
    border-radius: 20px;
    background: #e91e63;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
}
.__info {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 22px;
    color: #fff;

    h2 {
        font-size: 24px;
        font-weight: bold;
        margin: 0 0 6px;
        text-shadow: 0 2px 10px #0008;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    h5 {
        font-size: 14px;
        font-weight: normal;
        color: #e9d3a3;
        margin: 0 0 14px;
    }
    .__cta {
        display: inline-block;
        padding-bottom: 2px;
        border-bottom: 2px solid #d8a74a;
        font-size: 15px;
        font-weight: bold;
        transition: padding 0.3s;
    }
}

&:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 40px #0006;

    img { transform: scale(1.06); }
    .__cta { padding-right: 10px; padding-left: 10px; }
}
`;
